import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Select } from "antd";

import CustomTextField from "../../common-components/CustomTextField";
import LoginScreenBanner from "../../shared-resources/images/LeftPanelLoginScreens.png";
import {
  validateEmail,
  hasUpper,
  hasSpecialCharacter,
  hasNumber,
} from "../../shared-resources/utils";
import { login, newUserRegistration } from "../../actions/admin-actions";
import Loading from "../../common-components/Loading";
import ActionMessages from "../../common-components/ActionMessages";
import { accessRoles } from "../../shared-resources/dumpData";

function CreateUser() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isBtnClick, setIsBtnClick] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    role: "",
    emailId: "",
    empId: "",
    password: "",
    confirmPassword: "",
  });

  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        overflow: "hidden",
      },
    },
    loginwrapper: {
      background: "#fff",
      textAlign: "center",
    },
    fieldStyle: {
      width: "60%",
      margin: "8px auto",
    },
    welcomeHead: {
      fontSize: theme.spacing(3),
      letterSpacing: "0px",
      color: "#3D3D3D",
      opacity: "1",
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },

    loginNote: {
      fontSize: theme.spacing(1.75),
      letterSpacing: "0px",
      marginBottom: theme.spacing(1.5),
    },

    loginBtn: {
      textTransform: "none",
      borderRadius: theme.spacing(3),
      background: "#0176D3 !important",
      fontWeight: 500,
      width: "60%",
      marginTop: theme.spacing(4),
      padding: "12px 0 !important",
    },
    fieldsGrid: {
      position: "relative",
    },
    bannerSection: {
      background: "#2354E8",
    },
    loginGrid: {
      height: window.innerHeight + 32,
    },
    loginBanner: {
      marginTop: "45%",
    },
    fieldTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      fontSize: "13px",
      textAlign: "left !important",
    },
    loginNote: {
      fontSize: theme.spacing(1.75),
      letterSpacing: "0px",
      marginBottom: theme.spacing(1.5),
      textAlign: "center !important",
      marginTop: "16px",
    },
    firstColumnValidations: {
      textAlign: "initial",
      fontSize: theme.spacing(1.5),
      padding: "4px 0",
    },
    secondColumnValidations: {
      textAlign: "initial",
      fontSize: theme.spacing(1.5),
      padding: "4px 0",
    },
    greenValid: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: "50%",
      display: "inline-block",
      background: "#15C70F",
      marginRight: theme.spacing(0.5),
    },
    redInValid: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: "50%",
      display: "inline-block",
      background: "#CD202E",
      marginRight: theme.spacing(0.5),
    },
  }));
  const classes = useStyles();
  const newUserRegistrationData = useSelector(
    (state) => state.adminReducer.newUserRegistration
  );
  useEffect(() => {
    if (newUserRegistrationData && isBtnClick) {
      setLoading(false);
      setEmptyErrMsg(true);
      setMsgType(newUserRegistrationData.status === 200 ? "success" : "error");
      setMsgText(newUserRegistrationData.message);
      setIsBtnClick(false);
    }
  }, [newUserRegistrationData]);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onChangeText = (e, type) => {
    const changeData = JSON.parse(JSON.stringify(formData));
    console.log(type);
    changeData[type] = e.target.value;
    setFormData(changeData);
  };

  const onRoleChange = (val) => {
    const changeData = JSON.parse(JSON.stringify(formData));
    changeData.role = val;
    setFormData(changeData);
  };
  const onCreateClick = () => {
    setIsBtnClick(true);
    if (
      formData.firstName.toString().trim() === "" ||
      formData.lastName.toString().trim() === "" ||
      formData.emailId.toString().trim() === "" ||
      formData.empId.toString().trim() === "" ||
      formData.role.toString().trim() === "" ||
      formData.password.toString().trim() === "" ||
      formData.confirmPassword.toString().trim() === ""
    ) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please fill required fields`);
      return;
    }
    if (formData.firstName.toString().trim().length > 20) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`First name cannot have more than 20 characters`);
      return;
    }
    if (formData.lastName.toString().trim().length > 20) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Last name cannot have more than 20 characters`);
      return;
    }
    const regEx = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
    if (!formData.firstName.toString().trim().match(regEx)) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter only alphabets in first name`);
      return;
    }
    if (!formData.lastName.toString().trim().match(regEx)) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter only alphabets in last name`);
      return;
    }
    if (!validateEmail(formData.emailId.toString().trim())) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter valid email`);
      return;
    }
    if (formData.password.toString().length < 8) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Password should be atleast 8 charaters long`);
      return;
    }
    if (!hasUpper(formData.password.toString())) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Password should have atleast one capital letter`);
      return;
    }
    if (!hasSpecialCharacter(formData.password.toString())) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Password should have atleast one special character`);
      return;
    }
    if (!hasNumber(formData.password.toString())) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Password should have atleast one number`);
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Passwords didn't match`);
      return;
    }
    if (
      formData.password !== "" &&
      formData.emailId !== "" &&
      validateEmail(formData.emailId)
    ) {
      dispatch(newUserRegistration(formData));
      setLoading(true);
    }
  };

  return (
    <div className={classes.loginwrapper}>
      <Grid container spacing={4} className={classes.loginGrid}>
        <Grid
          item
          lg={6}
          className={classes.bannerSection}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "100vh" }}
        >
          <div className={classes.loginBanner}>
            <img src={LoginScreenBanner} style={{ width: "330px" }} />
          </div>
        </Grid>
        <Grid
          item
          lg={6}
          style={{ padding: "20px 32px 20px 20px", marginTop: "40px" }}
        >
          <Grid container spacing={2}>
            <Grid item lg={12} style={{ fontSize: "18px", fontWeight: 600 }}>
              Create User
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                First Name
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.firstName}
                onChangeItem={(e) => onChangeText(e, "firstName")}
                labelVal="First Name"
                id="firstName"
                errorValue={formData.firstName.trim() === "" && isBtnClick}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Last Name
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.lastName}
                onChangeItem={(e) => onChangeText(e, "lastName")}
                labelVal="Last Name"
                id="lastName"
                errorValue={formData.lastName.trim() === "" && isBtnClick}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Email
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.emailId}
                onChangeItem={(e) => onChangeText(e, "emailId")}
                labelVal="Email"
                id="emailId"
                errorValue={formData.emailId.trim() === "" && isBtnClick}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Employee ID
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.empId}
                onChangeItem={(e) => onChangeText(e, "empId")}
                labelVal="Employee ID"
                id="empId"
                errorValue={formData.empId.trim() === "" && isBtnClick}
              />
            </Grid>
            <Grid item lg={6} style={{ textAlign: "left" }}>
              <div className={classes.fieldTitle}>
                Role
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <Select
                showSearch
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Search to Select"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  )
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase())
                }
                options={accessRoles}
                onChange={onRoleChange}
                className={
                  isBtnClick && formData.role === "" ? "antSelectError" : ""
                }
                value={formData.role}
              />
            </Grid>
            <Grid item lg={6} />
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Password
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.password}
                onChangeItem={(e) => onChangeText(e, "password")}
                labelVal="Password"
                id="passwordCreate"
                errorValue={formData.password.trim() === "" && isBtnClick}
                type="password"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Confirm Password
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.confirmPassword}
                onChangeItem={(e) => onChangeText(e, "confirmPassword")}
                labelVal="Confirm Password"
                id="confirmPassword"
                errorValue={
                  formData.confirmPassword.trim() === "" && isBtnClick
                }
                type="password"
              />
            </Grid>
            <Grid item lg={12} style={{ textAlign: "left" }}>
              <Grid container spacing={2}>
                <Grid item lg={12} className={classes.loginNote}>
                  Password must contain the below
                </Grid>
                <Grid item lg={3} />
                <Grid item lg={3} className={classes.firstColumnValidations}>
                  <span
                    className={
                      hasUpper(formData.password)
                        ? classes.greenValid
                        : classes.redInValid
                    }
                  />
                  Capital letter
                </Grid>
                <Grid item lg={3} className={classes.secondColumnValidations}>
                  <span
                    className={
                      hasNumber(formData.password)
                        ? classes.greenValid
                        : classes.redInValid
                    }
                  />
                  Atleast one number
                </Grid>
                <Grid item lg={3} />
                <Grid item lg={3} />
                <Grid item lg={3} className={classes.firstColumnValidations}>
                  <span
                    className={
                      hasSpecialCharacter(formData.password)
                        ? classes.greenValid
                        : classes.redInValid
                    }
                  />
                  Special character
                </Grid>
                <Grid item lg={4} className={classes.secondColumnValidations}>
                  <span
                    className={
                      formData.password.trim().length >= 8
                        ? classes.greenValid
                        : classes.redInValid
                    }
                  />
                  Atleast 8 character long
                </Grid>
                <Grid item lg={2} />
              </Grid>
            </Grid>
            <Grid item lg={12}>
              <Button
                m={3}
                variant="contained"
                color="primary"
                disableElevation
                className={classes.loginBtn}
                type="submit"
                onClick={onCreateClick}
              >
                Create User
              </Button>
            </Grid>
            <Grid item lg={12}>
              <span
                style={{
                  color: "#09659c",
                  fontWeight: 600,
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => history.push("/login")}
              >
                Cancel
              </span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {loading && <Loading />}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </div>
  );
}

export default CreateUser;
